// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1dfda13f","455":"dd8e69a6","977":"f365a5d9"}[chunkId] + ".chunk.js";
};